import AbstractAPI from '@/services/api/AbstractAPI';

export default class CompanyApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/company');
  }

  async balance() {
    return this.makeRequest('/balance', 'get');
  }

  async getLeadAlertSettings() {
    return this.makeRequest('/lead-alerts/', 'get');
  }

  async updateLeadAlertSettings(value) {
    return this.makeRequest('/lead-alerts/', 'put', value);
  }

  async getLeadDeliverySettings() {
    return this.makeRequest('/lead-delivery/', 'get');
  }

  async updateLeadDeliverySettings(value) {
    return this.makeRequest('/lead-delivery/', 'put', value);
  }

  accreditations(coverage) {
    const params = {coverage};
    return this.makeRequest('/accreditations/', 'get', {params});
  }

  saveAccreditations(accreditations) {
    return this.makeRequest('/accreditations/', 'put', accreditations);
  }

  accreditationWorkTypes(companyAccreditationId) {
    return this.makeRequest(`/accreditations/${companyAccreditationId}/work-types`, 'get');
  }

  user() {
    return this.makeRequest('/user', 'get');
  }

  updateUser(email, receiveMarketingEmail, invoiceEmail, invoiceEmailOnly) {
    return this.makeRequest('/user/', 'put', {email, receive_marketing_email: receiveMarketingEmail, invoiceEmail, invoiceEmailOnly});
  }

  updatePassword(password, confirmedPassword) {
    return this.makeRequest('/user/update-password', 'put', {new_password: password, confirmed_password: confirmedPassword});
  }

  register(formData) {
    return this.makeRequest('/register', 'post', formData);
  }

  async remainingCredit() {
    return this.makeRequest('/remaining-credit', 'get');
  }

  async getListing() {
    return this.makeRequest('/listing/', 'get');
  }

  async saveListing(listing) {
    return await this.makeRequest('/listing/', 'put', {listing})
  }

  async saveListingLogo(data) {
    return this.client.post(this.version + this.baseUrl +`/listing/image/logo`, data.fd, {
      headers: {'Content-Type': 'multipart/form-data' }
    })
  }

  async saveListingImages(data) {
    return this.client.post(this.version + this.baseUrl +`/listing/image/`, data.fd, {
      headers: {'Content-Type': 'multipart/form-data' }
    })
  }
  async updateListingImage(data) {
      return this.client.post(this.version + this.baseUrl +`/listing/image/update/${data.fd.get('id')}`, data.fd, {
        headers: {'Content-Type': 'multipart/form-data' }
      })
    }

  async getCompany() {
    return await this.makeRequest('/', 'get');
  }

  updateCompany(options) {
    return this.makeRequest('/update', 'put', options);
  }

  async removeImage(id) {
    await this.makeRequest(`/listing/image/${id}`, 'delete');
  }

  getLiveListings() {
    return this.makeRequest('/listing/all-active', 'get');
  }
}
